import { SagaNodeStatus, sagaNodeStatusColor, type SagaWorkflowChildDto } from '@/dtos/SagaWorkflow'
import { Badge, Box, Flex, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { SagaWorkflowDiagram } from './SagaWorkflowDiagram'

// A collapsible nested diagram for one sub-saga. Collapsed by default; the nested React Flow renders only when opened
// (keeps large orchestrator fan-outs cheap).
export const SubSagaGroup = ({ child, depth }: { child: SagaWorkflowChildDto; depth: number }) => {
  const [open, setOpen] = useState(false)

  // The current node drives both the badge text (its display label) and colour (its run status) — matching the diagram.
  const currentNode = child.graph.nodes.find(n => n.state === child.graph.currentState)

  return (
    <Box borderWidth="1px" borderColor="gray.200" borderRadius="md" overflow="hidden">
      <Flex
        align="center"
        gap={2}
        p={2}
        bg="gray.50"
        cursor="pointer"
        onClick={() => setOpen(o => !o)}
        _hover={{ bg: 'gray.100' }}
      >
        <Text fontSize="sm" w={4} color="gray.500">{open ? '▾' : '▸'}</Text>
        <Text fontSize="sm" fontWeight="medium">Pod-saga: {child.relationLabel}</Text>
        <Badge ml="auto" colorScheme={sagaNodeStatusColor[currentNode?.status ?? SagaNodeStatus.Pending]}>
          {currentNode?.label ?? child.graph.currentState}
        </Badge>
      </Flex>
      {open && (
        <Box p={2}>
          <SagaWorkflowDiagram graph={child.graph} depth={depth} />
        </Box>
      )}
    </Box>
  )
}
